$(document).ready(function () {
    // Footer Navigation
    $('.footer--column').on('click', function (event) {
        $(this).toggleClass('is--active');
    });

    // Sidebar Navigation
    var openSidebar = function () {
        $('#nav_pop_2, #nav_button_2').removeClass('is--active');
        $('#nav_button').toggleClass('is--active');
        $('#nav_pop').toggleClass('is--active');
    };
    var closeSidebar = function () {
        $('#nav_button').removeClass('is--active');
        $('#nav_pop').removeClass('is--active');
    };

    $('#nav_button').click(function (event) {
        event.stopPropagation();
        openSidebar();
        $('.nav_pop-img img').attr('src', window.defaultImage);
    });

    $(document).click(function (event) {
        if (!$(event.target).closest('#nav_pop').length) {
            closeSidebar();
        }
    });

    // Change image on link hover
    $('#nav_pop li a').hover(
        function () {
            var linkIndex = $(this).data("image");
            $('.nav_pop-img img').attr('src', linkIndex + '.jpg');
        }
    );

    // Responsive Navigation
    var openRsnav = function () {
        $('body').addClass('rsnav-open');
    };
    var closeRsnav = function () {
        $('body').removeClass('rsnav-open');
    };

    $('#open_rsnav').click(function (event) {
        event.stopPropagation();
        openRsnav();
    });

    $('#close_rsnav').click(function (event) {
        event.stopPropagation();
        closeRsnav();
    });

    $(document).click(function (event) {
        if (!$(event.target).closest('#rsnav').length) {
            closeRsnav();
        }
    });

    // Menu Accordion
    $(".rsnav_accordion").click(function () {
        $(this).toggleClass("open");
        if ($(this).hasClass("open")) {
            $(".rsnav_accordion").not(this).removeClass("open");
        }
    });

    // Smooth Scroll
    $(document).on('click', 'a[href^="#"]', function (e) {
        var id = $(this).attr('href');
        var $id = $(id);
        if ($id.length === 0) {
            return;
        }
        e.preventDefault();
        var pos = $id.offset().top;
        $('body, html').animate({ scrollTop: pos });
    });

    // Preload Images
    var preloadImages = function (imageArray) {
        imageArray.forEach(function (src) {
            var img = new Image();
            img.src = src;
        });
    };

    preloadImages(window.preloadImages);

    // Stars Animation
    var blurAmount = 0.85;
    var Space = function () {
        this.fps = 60;
        this.canvas = null;
        this.width = 0;
        this.height = 0;
        this.minVelocity = 5;
        this.maxVelocity = 30;
        this.starsCount = 50;
        this.stars = [];
        this.intervalId = 0;
    };

    var Star = function (x, y, radius, velocityX, velocityY) {
        this.x = x;
        this.y = y;
        this.radius = radius;
        this.velocityX = velocityX;
        this.velocityY = velocityY;
    };

    Space.prototype.start = function () {
        var self = this;
        for (var i = 0; i < this.starsCount; i++) {
            var starRad = Math.random() * 2 + 1;
            var velocityX = Math.random() * (this.maxVelocity - this.minVelocity) + this.minVelocity;
            var velocityY = Math.random() * (this.maxVelocity - this.minVelocity) + this.minVelocity;
            if (Math.random() > 0.5) velocityX *= -1;
            if (Math.random() > 0.5) velocityY *= -1;
            this.stars.push(new Star(
                Math.random() * this.width,
                Math.random() * this.height,
                starRad,
                velocityX,
                velocityY
            ));
        }

        this.intervalId = setInterval(function () {
            self.update();
            self.draw();
        }, 1000 / this.fps);
    };

    Space.prototype.update = function () {
        var dt = 1 / this.fps;
        for (var i = 0; i < this.stars.length; i++) {
            var star = this.stars[i];
            star.x += dt * star.velocityX;
            star.y += dt * star.velocityY;
            if (star.x > this.width) star.x = 0;
            if (star.x < 0) star.x = this.width;
            if (star.y > this.height) star.y = 0;
            if (star.y < 0) star.y = this.height;
        }
    };

    Space.prototype.draw = function () {
        var ctx = this.canvas.getContext("2d");
        ctx.globalAlpha = blurAmount;
        ctx.fillStyle = 'rgba(22, 27, 27, 1)';
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.73)';
        for (var i = 0; i < this.stars.length; i++) {
            var star = this.stars[i];
            ctx.beginPath();
            ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2, false);
            ctx.fill();
        }
    };

    Space.prototype.initialise = function (div) {
        var self = this;
        this.containerDiv = div;
        this.width = window.innerWidth;
        this.height = window.innerHeight;

        window.addEventListener('resize', function () {
            self.width = window.innerWidth;
            self.height = window.innerHeight;
            self.canvas.width = self.width;
            self.canvas.height = self.height;
            self.draw();
        });

        var canvas = document.createElement('canvas');
        div.appendChild(canvas);
        this.canvas = canvas;
        this.canvas.width = this.width;
        this.canvas.height = this.height;
    };

    var container = document.getElementById('space');
    var space = new Space();
    space.initialise(container);
    space.start();
});